import React, { useState, useEffect } from "react"
import "./index.css"
import { loadStripe } from "@stripe/stripe-js"
import { Elements } from "@stripe/react-stripe-js"
import { Modal } from "react-bootstrap"
import { useStaticQuery, graphql } from "gatsby"
import Checkout from "./Checkout"
import $ from "jquery"

const stripePromise = loadStripe("pk_test_51Rs2ivIdHPhCddPjyIViKxkqvm9WwAlH4L3tzLIB4UmZLSX8kS8htx94VjhZgGTZ03Z47s6aq5oThCGX9PhS9Q7U0099cwAx8t")

const Invoice = ({
  toggleInvoice,
  togglePopup,
  invoiceLogo,
  titleOfQuote,
  invoiceURL,
  serviceDescription,
  fullName,
  email,
  companyName,
  serviceNote,
  mgmtPlanOption,
  projPlanOption,
  contractTerm,
  duration,
  amount,
  subEndDate,
  oneTimeNote,
  oneTimeAmount,
  vatPercentage,
}) => {
  const data = useStaticQuery(graphql`
    query {
      allContentfulTestDrivePlans(sort: { fields: createdAt }) {
        nodes {
          checkboxText
          buttonOne
          buttonTwo
        }
      }
      allContentfulInvoice {
        nodes {
          headerAddressLine1
          headerAddressLine2
          headerAddressLine3
          headerAddressLine4
          headerPhone
          headerWebsite
          headerCompanyNo
          headerVatRegNo
        }
      }
    }
  `)
  const { allContentfulTestDrivePlans, allContentfulInvoice } = data

  const [btnText, setBtnText] = useState(
    allContentfulTestDrivePlans.nodes[0].buttonOne
  )
  const [paymentMethod, setPaymentMethod] = useState("card")
  const [vatButtonText, setVatButtonText] = useState(
    "Click here to display VAT"
  )

  useEffect(() => {
    // center popup box on screen
    $(".modal-dialog").addClass("modal-dialog-centered")
  })

  let durationText
  if (contractTerm === "Annually") {
    durationText = duration === 1 ? "Year" : "Years"
  } else if (contractTerm === "Monthly") {
    durationText = duration === 1 ? "Month" : "Months"
  }

  let totalCost = amount + oneTimeAmount
  let vat = vatPercentage / 100
  let vatTotal = totalCost * vat
  let totalAfterVat = totalCost + vatTotal

  const showVAT = () => {
    let vatDiv = document.getElementById("show-vat")
    // toggle display of vat div
    if (vatDiv.style.display === "none") {
      vatDiv.style.display = "block"
    } else {
      vatDiv.style.display = "none"
    }
    // change vat button text
    if (vatDiv.style.display === "none") {
      setVatButtonText("Click here to display VAT")
    } else {
      setVatButtonText("Click here to hide VAT")
    }
  }

  const showHideStripeOptions = () => {
    let checkbox = document.getElementById("paymentOption")
    if (checkbox.checked) {
      setBtnText(allContentfulTestDrivePlans.nodes[0].buttonTwo)
      setPaymentMethod("sepa")
    } else {
      setBtnText(allContentfulTestDrivePlans.nodes[0].buttonOne)
      setPaymentMethod("card")
    }
  }

  return (
    <div>
      <Modal
        show={toggleInvoice}
        onHide={() => {
          toggleInvoice()
          togglePopup()
        }}
        className="invoice-popup main-text-color"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="col-sm-12 col-md-12 col-lg-12">
            <div className="card w-100">
              <div
                className="card-header text-center"
                style={{ backgroundColor: "#e5edf8" }}
              >
                <img
                  src={invoiceLogo}
                  className="card-img-top embed-responsive-item"
                  style={{ marginBottom: "10px" }}
                  alt="Workeye Logo"
                />
                <div className="row">
                  <div
                    className="column"
                    style={{ float: "left", width: "50%" }}
                  >
                    <p className="invoice-p">
                      {allContentfulInvoice.nodes[0].headerAddressLine1}
                    </p>
                    <p className="invoice-p">
                      {allContentfulInvoice.nodes[0].headerAddressLine2}
                    </p>
                    <p className="invoice-p">
                      {allContentfulInvoice.nodes[0].headerAddressLine3}
                    </p>
                    <p className="invoice-p">
                      {allContentfulInvoice.nodes[0].headerAddressLine4}
                    </p>
                  </div>
                  <div
                    className="column"
                    style={{ float: "left", width: "50%" }}
                  >
                    <p className="invoice-p">
                      {allContentfulInvoice.nodes[0].headerPhone}
                    </p>
                    <p className="invoice-p">
                      {allContentfulInvoice.nodes[0].headerWebsite}
                    </p>
                    <p className="invoice-p">
                      {allContentfulInvoice.nodes[0].headerCompanyNo}
                    </p>
                    <p className="invoice-p">
                      {allContentfulInvoice.nodes[0].headerVatRegNo}
                    </p>
                  </div>
                </div>
              </div>

              <div className="card-body">
                <h3 style={{ marginBottom: "20px" }}>
                  <strong>{titleOfQuote}</strong>
                </h3>
                <h4 className="text-center">
                  Invoice No: <strong>{invoiceURL}</strong>
                </h4>
                <li className="list-group-item invoice-list-item">
                  Service Description:
                </li>
                <li className="list-group-item invoice-list-item invoice-item-indent">
                  {serviceDescription}
                </li>
                <li className="list-group-item invoice-list-item">
                  Customer Details:
                </li>
                <li className="list-group-item invoice-list-item invoice-item-indent">
                  {fullName}
                </li>
                <li className="list-group-item invoice-list-item invoice-item-indent">
                  {email}
                </li>
                <li className="list-group-item invoice-list-item invoice-item-indent">
                  {companyName}
                </li>
                <h3 className="text-center" style={{ marginTop: "1rem" }}>
                  Subscription Breakdown:
                </h3>

                <ul className="list-group" id="invoice-details">
                  <h4>
                    <li className="list-group-item invoice-list-item">
                      Ongoing Service Details:
                    </li>
                  </h4>
                  <li className="list-group-item invoice-list-item invoice-item-indent">
                    • {serviceNote}
                  </li>
                  <li className="list-group-item invoice-list-item">
                    <em>Description</em>
                  </li>

                  <ul className="list-group">
                    <li className="list-group-item invoice-list-item">
                      • Management Plan:{" "}
                      <p className="float-right invoice-p">
                        <strong>{mgmtPlanOption}</strong>
                      </p>
                    </li>
                    <li className="list-group-item invoice-list-item">
                      • Project Plan:{" "}
                      <p className="float-right invoice-p">
                        <strong>{projPlanOption}</strong>
                      </p>
                    </li>
                    <li className="list-group-item invoice-list-item">
                      • Charged:{" "}
                      <p className="float-right invoice-p">
                        <strong>{contractTerm}</strong>
                      </p>
                    </li>
                    <li className="list-group-item invoice-list-item">
                      • Duration:{" "}
                      <p className="float-right invoice-p">
                        <strong>
                          {duration} {durationText}
                        </strong>
                      </p>
                    </li>
                    <li className="list-group-item invoice-list-item">
                      • Amount:{" "}
                      <p className="float-right invoice-p">
                        <strong>€{amount}</strong>
                      </p>
                    </li>
                    <li className="list-group-item invoice-list-item">
                      • End Date:{" "}
                      <p className="float-right invoice-p">
                        <strong>{subEndDate}</strong>
                      </p>
                    </li>
                  </ul>

                  <h4 style={{ marginTop: ".5rem" }}>
                    <li className="list-group-item invoice-list-item">
                      Once Off Payment Details:
                    </li>
                  </h4>
                  <li className="list-group-item invoice-list-item invoice-item-indent">
                    • {oneTimeNote}
                  </li>
                  <li className="list-group-item invoice-list-item">
                    <em>Description</em>
                  </li>
                  <ul className="list-group">
                    <li className="list-group-item invoice-list-item">
                      • Amount:{" "}
                      <p
                        className="float-right"
                        style={{ marginBottom: "20px" }}
                      >
                        <strong>€{oneTimeAmount}</strong>
                      </p>
                    </li>
                  </ul>

                  <input
                    onClick={() => showVAT()}
                    style={{ width: "fit-content", margin: "4px 0" }}
                    className="btn btn-secondary"
                    value={vatButtonText}
                    type="button"
                    id="vat-button"
                  />
                  <div id="show-vat" style={{ display: "none" }}>
                    <li className="list-group-item invoice-list-item">
                      Cost before VAT:{" "}
                      <p className="float-right invoice-p">
                        <strong>€{totalCost}</strong>
                      </p>
                    </li>
                    <li className="list-group-item invoice-list-item">
                      VAT charged @ {vatPercentage}%:{" "}
                      <p className="float-right invoice-p">
                        <strong>€{vatTotal.toFixed(2)}</strong>
                      </p>
                    </li>
                  </div>
                  <div style={{ marginTop: "10px" }}></div>
                  <li className="list-group-item invoice-list-item">
                    Total Payment (incl. VAT):{" "}
                    <p className="float-right invoice-p">
                      <strong>€{totalAfterVat.toFixed(2)}</strong>
                    </p>
                  </li>
                </ul>
              </div>

              <div
                className="card-footer text-center"
                style={{ backgroundColor: "#e5edf8" }}
              >
                <label htmlFor="paymentOption" style={{ marginTop: ".5rem" }}>
                  {allContentfulTestDrivePlans.nodes[0].checkboxText}
                  &nbsp;&nbsp;
                  <span>
                    <input
                      type="checkbox"
                      id="paymentOption"
                      onClick={() => showHideStripeOptions()}
                    />
                  </span>
                </label>

                <div className="mb-sm-3">
                  <div style={{ marginTop: "1rem" }}>
                    <Elements stripe={stripePromise}>
                      <Checkout
                        planamount={totalAfterVat}
                        planname={"Custom Quote"}
                        fullName={fullName}
                        companyName={companyName}
                        email={email}
                        paymentMethod={paymentMethod}
                        btnText={btnText}
                        toggleInvoice={toggleInvoice}
                      />
                    </Elements>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default Invoice
